export default "__VITE_ASSET__pGv2X8Nk__"